export default {
  sign_in_refused:
    "Zendesk couldn't sign you in to the Help Center. Please try again, or contact support if it keeps happening.",
  sso_unavailable:
    "We couldn't open the Help Center for this account. Please try again, or contact support.",
}
